import "./FAQ.css";

import { useEffect, useState } from "react";

import FAQItem from "../../components/FAQItem/FAQItem";
import { FAQListModel } from "../../models/faqModel";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import Questions from "./questions";

const FAQ = () => {
  const [activeQuestion, setActiveQuestion] = useState<number | null>(null);
  const [searchClicked, setSearchClicked] = useState<boolean>(false);
  const [searchPhrase, setSearchPhrase] = useState<string>("");
  useEffect(() => {
    if (searchPhrase?.length === 0) setSearchClicked(false);
  }, [searchPhrase]);
  return (
    <div className="faq-container">
      <Header />
      <div className="faq-content">
        <div className="faq-header">
          <p
            className="faq-heading"
            style={{
              visibility:
                window.innerWidth > 480
                  ? "visible"
                  : !searchClicked
                  ? "visible"
                  : "hidden",
            }}
          >
            Frequently Asked Questions
          </p>
          {/* {!searchClicked ? (
            <FontAwesomeIcon
              className="faq-search-icon"
              icon={faSearch}
              size="3x"
              color="#18283c"
              onClick={() => setSearchClicked(true)}
            />
          ) : (
            <input
              placeholder="Search"
              className="faq-searchbox"
              onChange={(e) => setSearchPhrase(e.target.value)}
            />
          )} */}
        </div>
        <div className="faq-questions-container">
          {Questions.map(
            ({ title, questions }: FAQListModel, index: number) => (
              <FAQItem
                searchPhrase={searchPhrase}
                key={index}
                id={index}
                title={title}
                questions={questions}
                activeQuestion={activeQuestion}
                setActiveQuestion={setActiveQuestion}
              />
            )
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default FAQ;
